import React from 'react'
import PropTypes from 'prop-types'

/**
 * WARNING: Make light use of this component. It is a security risk to use this.
 */
const HtmlStringElement = ({ elementType, html, classes, styles }) => {
  switch (elementType) {
  case 'h1':
    return (<h1 style={styles} className={classes} dangerouslySetInnerHTML={{ __html: html }} />)
  case 'h2':
    return (<h2 style={styles} className={classes} dangerouslySetInnerHTML={{ __html: html }} />)
  case 'h3':
    return (<h3 style={styles} className={classes} dangerouslySetInnerHTML={{ __html: html }} />)
  case 'p':
    return (<p style={styles} className={classes} dangerouslySetInnerHTML={{ __html: html }} />)
  case 'span':
    return (<span style={styles} className={classes} dangerouslySetInnerHTML={{ __html: html }} />)
  case 'div':
  default:
    return (<div style={styles} className={classes} dangerouslySetInnerHTML={{ __html: html }} />)
  }
}

HtmlStringElement.propTypes = {
  elementType: PropTypes.string,
  html: PropTypes.string.isRequired,
  classes: PropTypes.string,
  styles: PropTypes.string
}

export default HtmlStringElement
